export default {
    title: 'The Geography of Bliss',
    cover: '/dev-content-files/epub_cover.jpeg',
    tags: {
        keyword: ['Travel', 'Psychology', 'Happiness', 'Culture', 'Geography', 'Self-Help', 'Humor', 'Social Science'],
        author: ['Eric Weiner'],
        category: ['Travel', 'Psychology'],
        collection: ['Non-Fiction'],
    },
    publication_date: '2008',
    issue_url: 'volpe.localhost',
    twitterUser: 'publicala',
    lang: 'en',
    aboutThisPublication:
        "Part foreign affairs discourse, part humor, and part twisted self-help guide, The Geography of Bliss takes the reader from America to Iceland to India in search of happiness, or, in the crabby author's case, moments of 'un-unhappiness.' The book uses a beguiling mixture of travel, psychology, science and humor to investigate not what happiness is, but where it is.",
};
